import type { AnyAction } from "redux";
import type { IIndustryResearchModule } from "app/pages/industry-analysis/overview/utils/types";
import {
    REQUEST_INDUSTRY_RESEARCH_MODULE,
    FINISH_REQUEST_INDUSTRY_RESEARCH_MODULE,
    RECEIVE_INDUSTRY_RESEARCH_MODULE_DATA,
} from "app/action_types/industry_research_module_action_types";

const DEFAULT_STATE: IIndustryResearchModule = {
    isLoading: false,
    rawData: undefined as FixmeType,
};

export const industryResearchModule = (
    state: IIndustryResearchModule = DEFAULT_STATE,
    action: AnyAction,
): IIndustryResearchModule => {
    switch (action.type) {
        case REQUEST_INDUSTRY_RESEARCH_MODULE:
        case FINISH_REQUEST_INDUSTRY_RESEARCH_MODULE:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        case RECEIVE_INDUSTRY_RESEARCH_MODULE_DATA:
            return {
                ...state,
                rawData: action.rawData,
            };
        default:
            return state;
    }
};
